export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/downloadAppModal/1.png";